export const CALENDAR_ACCEPTANCE_STATUS_MAP = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DECLINED: "declined",
  TENTATIVE: "tentative",
} as const;

export const CALENDAR_ACCEPTANCE_STATUS_COLORS_MAP = {
  [CALENDAR_ACCEPTANCE_STATUS_MAP.PENDING]: "text-yellow-400",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.ACCEPTED]: "text-green-600",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.DECLINED]: "text-red-500",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.TENTATIVE]: "text-purple-500",
} as const;

export const CALENDAR_ACCEPTANCE_STATUS_LABELS_MAP = {
  [CALENDAR_ACCEPTANCE_STATUS_MAP.PENDING]: "Pending",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.ACCEPTED]: "Accepted",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.DECLINED]: "Declined",
  [CALENDAR_ACCEPTANCE_STATUS_MAP.TENTATIVE]: "Tentative",
} as const;
